// import { allapiAction } from "@/Redux/common/action";
// import { URL } from "@/Redux/common/url";
// import Link from "next/link";
// import { useRouter } from "next/router";
import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CoustomImg from "../CoustomImg/CoustomImg";
import TruncateText from "../TruncateText/TruncateText";
import OurWork from "../OurWork/OurWork";
import { Button, Modal, Space } from "antd";
// import CoustomImg from "../../Component/CoustomImg/CoustomImg";
// import TruncateText from "../../Component/TruncateText/TruncateText";

function Courses() {
  const dispatch = useDispatch();
  const router = useNavigate();

  const locationv = useLocation();

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  // const { search, page, location } = useParams();
  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const get_category_Filter = useSelector((state) =>
    state?.allapi?.get_category_Filter ? state?.allapi?.get_category_Filter : []
  );

  console.log(get_category_Filter);

  const pageno = page ? page : 1;

  const listdata = get_product_list?.docs ? get_product_list?.docs : [];
  const listdataListing = get_product_list?.listingList?.docs
    ? get_product_list?.listingList?.docs
    : [];
  // get_product_list

  useEffect(() => {
    // searchProduct

    if (search) {
      if (location) {
        dispatch(
          allapiAction.getDeducateListuserSide({
            page: pageno,
            id: search,
            location,
          })
        );
      } else {
        dispatch(
          allapiAction.getDeducateListuserSide({ page: pageno, id: search })
        );
      }
    } else {
      if (location) {
        dispatch(
          allapiAction.getDeducateListuserSide({ page: pageno, location })
        );
      } else {
        dispatch(allapiAction.getDeducateListuserSide({ page: pageno }));
      }
    }
    dispatch(allapiAction.getfiltercategory({}));
    return () => {};
  }, [locationv.search]);

  const henldetofilterbyCate = (e) => {
    if (search) {
      dispatch(
        allapiAction.getDeducateListuserSide({
          page: pageno,
          id: search,
          cateId: e,
        })
      );
    } else {
      dispatch(
        allapiAction.getDeducateListuserSide({ page: pageno, cateId: e })
      );
    }
  };
  const [childcateee, setchildcateee] = useState("");
  const hendletoviewchlidcate = (e) => {};

  const items = get_product_list?.totalDocs;
  const itemsPerPage = 52;
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setPageCount(Math.ceil(items && items / itemsPerPage));
  }, [itemOffset, itemsPerPage, get_product_list, items]);

  const handlePageClick = (event) => {
    const data = event?.selected + 1;
    // const newOffset = (event.selected * itemsPerPage) % items;
    // setItemOffset(newOffset);
    // setPage(data);
    const srch = search ? search : "";
    router("/products?search=" + srch + "&page=" + data);
    window.scrollTo(12, 0);
    // dispatch(allapiAction.lostfoundlistpublic({ page: data }));
  };

  const [windowWidth, setWindowWidth] = useState(600);

  // Update window width when the window is resized
  useLayoutEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [courceDetails, setcourceDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const hendleToMonthIncrease = () => {
    const e = courceDetails?.month ? courceDetails?.month + 1 : 1;
    setcourceDetails({ ...courceDetails, month: e });
  };
  const hendleToMonthDecrease = () => {
    if (courceDetails?.month > 1) {
      const e = courceDetails?.month ? courceDetails?.month - 1 : 1;
      setcourceDetails({ ...courceDetails, month: e });
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleCancel1 = () => {
    setIsModalOpen1(false);
  };

  const showModal = (e) => {
    console.log(e);
    setcourceDetails(e);
    setIsModalOpen(true);
  };

  const hendleToSubmit = (data) => {
    // createOrderCourse
    setIsModalOpen(false);
    setIsModalOpen1(true);
  };
  const hendleToSubmit1 = async () => {
    // createOrderCourse

    const res = await dispatch(
      allapiAction.createOrderCourse({
        courseId: courceDetails?._id,
        months: courceDetails?.month,
      })
    );
    if (res?.success) {
      setIsModalOpen(false);
      setIsModalOpen1(false);
      router("/accounts/our-courses");
    }
  };

  const cards = [
    {
      id: 1,
      title: "Railway Mahapack",
      tag: "Hinglish",
      start: "Starts on 15 May, 2024",
      end: "Ends on 30 Nov, 2026",
      price: "₹1,248",
      oldPrice: "₹2,499",
      discount: "50%",
      img: "https://images.unsplash.com/photo-1522202229410-3e4f4d2f0fa2?auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 2,
      title: "Intercity Express 2.0",
      tag: "NEW",
      start: "Starts on 30 Oct, 2025",
      end: "Ends on 30 Aug, 2026",
      price: "₹999",
      oldPrice: "₹2,499",
      discount: "60%",
      img: "https://images.unsplash.com/photo-1519337265831-281ec6cc8514?auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 3,
      title: "Intercity Express RRB",
      tag: "Hinglish",
      start: "Starts on 6 Oct, 2025",
      end: "Ends on 30 Aug, 2026",
      price: "₹999",
      oldPrice: "₹2,499",
      discount: "60%",
      img: "https://images.unsplash.com/photo-1541420651245-0f32c2c3928a?auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 4,
      title: "Complete Test Series",
      tag: "PRO",
      start: "Starts on 1 Jan, 2025",
      end: "Ends on 31 Dec, 2026",
      price: "₹1,499",
      oldPrice: "₹3,499",
      discount: "57%",
      img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=60",
    },
  ];

  return (
    <div className="container-fluid my-5 pt-5">
      <Modal
        title="Buy Course"
        open={isModalOpen}
        onOk={hendleToSubmit}
        onCancel={handleCancel}
      >
        <div>
          <h5>{courceDetails?.name}</h5>
          <p>{courceDetails?.description}</p>
          <p>Price: {courceDetails?.price}</p>
          <p>Duration: {courceDetails?.month} Month</p>
          <div className="d-flex justify-content-between align-items-center">
            <button
              onClick={hendleToMonthDecrease}
              className="btn btn-outline-secondary"
            >
              -
            </button>
            <span className="mx-3">{courceDetails?.month} Month</span>
            <button
              onClick={hendleToMonthIncrease}
              className="btn btn-outline-secondary"
            >
              +
            </button>
          </div>
          <p>Total: {courceDetails?.price * courceDetails?.month}</p>
        </div>
      </Modal>
      <Modal
        title="Buy Course"
        open={isModalOpen1}
        onOk={hendleToSubmit1}
        onCancel={handleCancel1}
      >
        <p>Are you sure you want to buy</p>
        <h2>{courceDetails?.name}</h2>
        <p> Total: {courceDetails?.price * courceDetails?.month}</p>
        <p>Month: {courceDetails?.month}</p>
      </Modal>

      <div className="container py-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-semibold"> All Courses</h2>
          <div>
            {/* <button className="btn btn-outline-secondary me-2">
              All Courses
            </button>
            <button className="btn btn-primary">Login/Register</button> */}
          </div>
        </div>
        <div className="row g-4">
          {listdata?.map((c, i) => (
            <div className="col-12 col-sm-6 col-lg-3" key={i}>
              <div className="card h-100 shadow-sm border-0">
                <div className="position-relative">
                  <img
                    src={URL?.API_BASE_URL + c.image}
                    className="card-img-top"
                    alt={c.name}
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                  <span className="badge bg-light text-dark position-absolute top-0 start-0 m-2">
                    {c.tag}
                  </span>
                </div>
                <div className="card-body d-flex flex-column justify-content-between">
                  <div>
                    <h5 className="card-title mb-2 fw-bold">{c.name}</h5>
                    {/* <p className="text-muted small mb-2">
                      {c.start} · {c.end}
                    </p> */}
                    <p className="small text-secondary">{c?.description}</p>
                  </div>
                  <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <h5 className="fw-bold mb-0">{c.price}</h5>
                        <small className="text-decoration-line-through text-muted">
                          {c.oldPrice}
                        </small>
                      </div>
                      {/* <div className="text-end">
                        <span className="badge bg-success text-white">
                          Discount of {c.discount} applied
                        </span>
                        <div className="text-muted small">
                          Plan starting from
                        </div>
                      </div> */}
                    </div>
                    <div className="d-flex gap-2">
                      <button className="btn btn-outline-primary w-50">
                        View Detail
                      </button>
                      <button
                        onClick={() =>
                          showModal({ ...Object.assign(c, { month: 1 }) })
                        }
                        className="btn btn-primary w-50"
                      >
                        BUY NOW
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
           
      </div>

      {/* <div className="ps-deal-of-day shewBox">
        <div className="ps-container">
          <div class="ps-layout--shop mt-30">
            
            <div class="ps-layout__right">
              <div class="ps-block--shop-features">
                <div class="ps-block__header">
                  <h3>Courses</h3>
                  <div class="ps-block__navigation">
                    <a class="ps-carousel__prev" href="#recommended1">
                      <i class="icon-chevron-left"></i>
                    </a>
                    <a class="ps-carousel__next" href="#recommended1">
                      <i class="icon-chevron-right"></i>
                    </a>
                  </div>
                </div>
                {listdata?.length == 0 && (
                  <div className="notfound">
                    <h2>Not Found</h2>
                  </div>
                )}
                <div className="row ps-section__content mt-10">
                  {" "}
                  {listdata &&
                    listdata?.map((data, i) => {
                      console.log(data);
                      return (
                        <div className="col-6 col-sm-3" key={i}>
                          <div className="recentlostfound">
                            <div className="ps-product">
                              <div className="ps-product__thumbnail  ps-product__thumbnailms">
                                <Link
                                  to={
                                    data?.typeof == "Listing"
                                      ? "/lesson/" + data?.slug
                                      : "/lesson/" + data?.slug
                                  }
                                >
                                  <CoustomImg
                                    url={URL.API_BASE_URL + data?.featureImage}
                                    altkey={data?.title}
                                    w1={200}
                                    w2={300}
                                    h1={200}
                                    h2={300}
                                  />
                                </Link>
                              </div>
                              <div className="ps-product__container">
                                <div className="ps-product__content">
                                  <Link
                                    className="ps-product__title"
                                    to={
                                      data?.typeof == "Listing"
                                        ? "/lesson/" + data?.slug
                                        : "/lesson/" + data?.slug
                                    }
                                  >
                                    <TruncateText
                                      text={data?.name}
                                      maxLength={windowWidth > 600 ? 25 : 15}
                                    />
                                   
                                  </Link>

                                  {data?.afterdiscountprice && (
                                    <p className="ps-product__price sale">
                                      ₹{data?.afterdiscountprice}{" "}
                                      <del>₹{data?.price} </del>
                                    </p>
                                  )}
                              
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container mt-20">
        <nav
          className="d-flex justify-content-between"
          aria-label="Page navigation"
        >
          <ReactPaginate
            breakLabel="..."
            nextLabel="Next"
            onPageChange={handlePageClick}
            className="paging_simple_numbersc pagination"
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="Previous"
            renderOnZeroPageCount={null}
          />
        </nav>
      </div>
      <OurWork />
    </div>
  );
}

export default Courses;
